'use client';

import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { createCookieStorage } from '../../Utils/CookieStorage';

export const favouritesAtom = atomWithStorage('favourites', [], createCookieStorage<string[]>([]), {
  getOnInit: true,
});

export const removeFromFavouritesAtom = atom(null, (_, set, heycarId) => {
  set(favouritesAtom, (currentFavourites: string[]) =>
    currentFavourites.filter((vehicleId: string) => vehicleId !== heycarId),
  );
});

export const addToFavouritesAtom = atom(null, (_, set, favData: { heycarId: string }) => {
  set(favouritesAtom, (currentFavourites: string[]) => [
    ...(currentFavourites || []),
    favData.heycarId,
  ]);
});
